import '../App.css';

function About() {
  return (
    <div className="about-container">
      <div className="about-box">
        <h1 className="about-title">About IDX Exchange</h1>
        <p className="about-desc">
          At IDX Exchange, we're a tech-driven company revolutionizing the real estate industry with cutting-edge solutions designed to empower real estate professionals.<br /><br />
          Our platform leverages advanced data analytics to predict property prices with precision and offers dynamic visualizations of real estate trends. With our plug-and-play website solutions, we seamlessly integrate MLS property search, AI-driven home value predictions, and interactive market analytics into one cohesive experience.<br /><br />
          We're not just providing tools; we're transforming how real estate professionals make decisions and engage with the market, unlocking unparalleled efficiency and growth opportunities.
        </p>
      </div>
    </div>
  );
}

export default About;
